import * as React from 'react';
import type { SvgProps } from 'react-native-svg';
import { SvgXml } from 'react-native-svg';

const xml = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.67676 11.9938C5.67676 11.7785 5.71402 11.5797 5.78856 11.3975C5.87137 11.2153 5.9956 11.0414 6.16123 10.8758L15.8382 1.40994C16.1198 1.13665 16.4594 1 16.8569 1C17.1302 1 17.3745 1.06625 17.5898 1.19876C17.8134 1.32298 17.9915 1.49275 18.124 1.70807C18.2565 1.9234 18.3227 2.1677 18.3227 2.44099C18.3227 2.83023 18.1695 3.17805 17.8631 3.48447L9.1426 11.9938L17.8631 20.5031C18.1695 20.8095 18.3227 21.1615 18.3227 21.559C18.3227 21.824 18.2565 22.0642 18.124 22.2795C17.9915 22.5031 17.8134 22.677 17.5898 22.8012C17.3745 22.9337 17.1302 23 16.8569 23C16.4594 23 16.1198 22.8592 15.8382 22.5776L6.16123 13.1118C5.9956 12.9462 5.87137 12.7723 5.78856 12.5901C5.71402 12.4079 5.67676 12.2091 5.67676 11.9938Z" />
  </svg>
`;

export const ArrowLeft = (props: SvgProps) => (
  <SvgXml xml={xml} width="100%" height="100%" {...props} />
);
